export const VOICE_PHASE = Object.freeze({
  IDLE: "IDLE", PERMISSION_PENDING: "PERMISSION_PENDING", RECORDING_HELD: "RECORDING_HELD",
  RECORDING_LOCKED: "RECORDING_LOCKED", PAUSED_LOCKED: "PAUSED_LOCKED", PROCESSING: "PROCESSING",
  PREVIEW: "PREVIEW", SENDING: "SENDING", FAILED: "FAILED", CANCELLED: "CANCELLED",
});
// CSS pixels, independent of screen density. Dominant-axis check avoids diagonal ambiguity.
export const VOICE_LOCK_DISTANCE = 64;
export const VOICE_CANCEL_DISTANCE = 88;
export const VOICE_MIN_SECONDS = 0.5;
// Existing request-audio backend contract: duration <= 60 * 60 seconds.
export const VOICE_MAX_SECONDS = 60 * 60;
export function voiceGesture(start, point) {
  const left = Math.max(0, start.x - point.x); const up = Math.max(0, start.y - point.y);
  if (left >= VOICE_CANCEL_DISTANCE && left > up * 1.2) return "cancel";
  if (up >= VOICE_LOCK_DISTANCE && up > left * 1.2) return "lock";
  return null;
}
export function voiceClock(seconds) {
  const whole = Math.max(0, Math.floor(seconds));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, "0")}`;
}
